namespace RioERP.Orders {
    export interface OrderEmailRequest extends Serenity.ServiceRequest {
        status?: string;
        ids?: string;
    }
}
